var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"title-ribbon",attrs:{"fluid":""}},[_c('b-row',{staticClass:"my-5",attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"10"}},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.text))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }